import {Controller} from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [
    "loading",
    "notUsed",
    "notUsedText",
    "usageList",
    "usageHeader",
    "listGroup",
    "warningIcon",
    "okButton",
    "deleteModeButton",
    "usesModal"
  ]
  static values = {
    mediaLibraryUrl: String,
    notUsedText: String,
    usedHereText: String,
    safeDeleteText: String,
    warningDeleteText: String,
    deleteUrl: { type: String, default: null },
    currentMode: { type: String, default: 'view' }
  }

  findUses({ params:  { assetName, findUsesUrl } }) {
    this.currentModeValue = 'view'
    this.loadAssetUses(assetName, findUsesUrl).then(r => this.displayResults(r, assetName))
    this.showModal()
  }

  findUsesWithForDelete({ params:  { assetName, findUsesUrl,  deleteUrl} }) {
    this.currentModeValue = 'delete'
    this.deleteUrlValue = deleteUrl
    this.loadAssetUses(assetName, findUsesUrl).then(r => this.displayResults(r, assetName))
    this.showModal()
  }

  async confirmDelete() {
    try {
      const response = await fetch(this.deleteUrlValue, {
        method: 'DELETE',
        headers: {
          'X-CSRF-Token': document.querySelector('[name="csrf-token"]').content,
          'Accept': 'application/json'
        }
      })

      if (response.ok) {
        $(this.usesModalTarget).modal('hide')
        window.location.href = this.mediaLibraryUrlValue
      } else {
        alert('Failed to delete asset. Please try again.')
      }
    } catch (error) {
      console.error('Delete error:', error)
      alert('Failed to delete asset. Please try again.')
    }
  }

  currentModeValueChanged() {
    if (this.currentModeValue === 'delete') {
      this.okButtonTarget.classList.add('hidden')
      this.deleteModeButtonTargets.forEach(button => button.classList.remove('hidden'))
    } else {
      this.deleteModeButtonTargets.forEach(button => button.classList.add('hidden'))
      this.okButtonTarget.classList.remove('hidden')
    }
  }

  showModal() {
    $('#asset-uses-modal').modal('show')
  }

  async loadAssetUses(assetName, findUsesUrl) {
    this.showLoading()

    try {
      const response = await fetch(findUsesUrl, {
        headers: {
          'Accept': 'application/json',
          'X-CSRF-Token': document.querySelector('[name="csrf-token"]').content
        }
      })

      if (!response.ok) {
        throw new Error('Failed to load asset uses')
      }

      return await response.json()
    } catch (error) {
      console.error('Error loading asset uses:', error)
      this.showError()
    }
  }

  displayResults(data, assetName) {
    const allUses = [
      ...(data.contents || []),
      ...(data.nodes || []),
      ...(data.pages || []),
      ...(data.reports || [])
    ]

    if (allUses.length === 0) {
      this.showNotUsed(assetName)
    } else {
      this.showUsageList(assetName, allUses)
    }
  }

  showLoading() {
    this.loadingTarget.classList.remove('hidden')
    this.notUsedTarget.classList.add('hidden')
    this.usageListTarget.classList.add('hidden')
    this.usesModalTarget.classList.remove('has-uses', 'no-uses')
  }

  hideLoading() {
    this.loadingTarget.classList.add('hidden')
  }

  showNotUsed(assetName) {
    this.hideLoading()
    this.notUsedTarget.classList.remove('hidden')
    this.usesModalTarget.classList.replace('has-uses', 'no-uses')

    if (this.currentModeValue === 'delete') {
      this.notUsedTextTarget.textContent = this.safeDeleteTextValue.replace('%{asset_name}', assetName)
    } else {
      this.notUsedTextTarget.textContent = this.notUsedTextValue.replace('%{asset_name}', assetName)
    }
  }

  showUsageList(assetName, uses) {
    this.hideLoading()
    this.usageListTarget.classList.remove('hidden')
    this.usesModalTarget.classList.replace('no-uses', 'has-uses')

    if (this.currentModeValue === 'delete') {
      this.usageHeaderTarget.textContent = this.warningDeleteTextValue.replace('%{asset_name}', assetName)
      this.warningIconTarget.classList.remove('hidden')
    } else {
      this.usageHeaderTarget.textContent = this.usedHereTextValue.replace('%{asset_name}', assetName)
      this.warningIconTarget.classList.add('hidden')
    }

    // Clear previous list items
    this.listGroupTarget.innerHTML = ''

    // Add items
    uses.forEach(item => { this.createListItem(item) })
  }

  createListItem(item) {
    const linkWrapper = document.createElement('div')
    linkWrapper.className = 'usage-link-item'

    const link = document.createElement('a')
    link.href = item.url
    link.className = 'usage-link'
    link.target = '_blank'

    if (item.type === 'Report') {
      link.innerHTML = `${item.name.trim()}`
    } else {
      link.innerHTML = `${item.variant.trim()}: ${item.name.trim()}`
    }


    linkWrapper.appendChild(link)
    this.listGroupTarget.appendChild(linkWrapper)
  }

  showError() {
    this.hideLoading()
    this.notUsedTarget.classList.remove('hidden')
    this.notUsedTarget.className = 'alert alert-danger'
    this.notUsedTextTarget.textContent = 'Error loading asset uses. Please try again.'
  }
}
